import { Component, ComponentFactoryResolver, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { ExtraService } from '../../core/services/extra.service';
import { ActivatedRoute, Router } from '@angular/router';
import * as firebase from 'firebase/app';
import { NewPageService } from '../../templates/new-page/service/new-page.service';
import { Constants } from '../../core/config/Constants';
import { SponsorsService } from '../../core/services/sponsors.service';
import { Sponsors } from '../../core/models/sponsors';
import { MultiUtility } from '../../shared/multi-utility';
import { MultiUtilityService } from '../../core/services/multi-utility.service';
import { Category } from '../../core/models/category';

@Component({
	selector: 'app-sponsors-add-new',
	templateUrl: './sponsors-add-new.component.html',
	styleUrls: ['./sponsors-add-new.component.css'],
	providers: [SponsorsService, ExtraService, NewPageService]
})
export class SponsorsAddNewComponent extends MultiUtility implements OnInit {
	@ViewChild('dropDown', { read: ViewContainerRef }) dropDown: ViewContainerRef;

	buttonMessage = Constants.SUBMIT_BUTTON_MESSAGE;
	eventId: string;

	// XYZ - What is this? SponsorType --> Yes
	pageTitle: string = 'Create Sponsors';
	editTitle: string = 'Edit Sponsors';
	pageAlias: string = 'sponsors-form';

	sponsorId: string;
	sponsorCount = 0;
	sponsor = new Sponsors();
	sponsorTypeText: string;

	categoryOrderList: Array<any> = [];

	bannerImageFile: File = null;
	iconImageFile: File = null;

	progress: { percentage: number } = { percentage: 0 };

	uploadImgTypeBanner = Constants.IMAGE_UPLOAD_TYPE_BANNER;
	uploadImgTypeIcon = Constants.IMAGE_UPLOAD_TYPE_ICON;


	log(event: boolean) {
		console.log(`Accordion has been ${event ? 'opened' : 'closed'}`);
	}

	constructor(private router: Router,
		newPageService: NewPageService,
		_cfr: ComponentFactoryResolver,
		private sponsorService: SponsorsService,
		extraService: ExtraService,
		multiUtilityService: MultiUtilityService,
		private route: ActivatedRoute) {

		super(multiUtilityService, extraService, newPageService, _cfr);
	}

	ngOnInit() {
		super.initComponentThings();
		this.initSponsorInfo();
	}

	private initThings() {
		this.aboutListUp(this.sponsor, this.dropDown);
		this.aboutListDown(this.sponsor, this.dropDown);
		this.aboutListRemove(this.sponsor);
	}

	private initSponsorInfo() {
		this.route.queryParams.subscribe(params => {
			this.eventId = params['eventId'];
			this.getSponsorCategory(params['eventId']);

			if (params['eventId']) {
				if (params['sponsorId']) {
					this.sponsorId = params['sponsorId'];
					this.getSponsorById(params['eventId'], params['sponsorId']);
				} else {
					this.getSponsorCount(params['eventId']);
				}
			}
			this.extraService.setCurrentEventId(params['eventId']);
		});
	}

	getSponsorCategory(id) {
		this.categoryOrderList = [];
		this.sponsorService.getSponsorType(id).subscribe(event => {
			if (event) {
				for (let key in event) {
					let sponsorOrderType = new Category(); // Should I make it some generic method, It is used by Sponsors also
					sponsorOrderType.$key = key;
					sponsorOrderType.position = event[key].position;
					sponsorOrderType.text = event[key].text;
					this.categoryOrderList[event[key].position] = sponsorOrderType;
				}
			}
		});
	}

	getSponsorById(eventId: string, sponsorId: string) {
		this.sponsorService.getSingleSponsor(eventId, sponsorId).subscribe(event => {
			if (event) {
				this.sponsor = event;
				console.log("huuh  " + this.sponsor);

				this.sponsor = new Sponsors();
				this.sponsor.name = event.name;
				this.sponsor.type = event.type === undefined ? null : event.type;
				this.sponsor.website = event.website === undefined ? null : event.website;
				this.sponsor.email = event.email === undefined ? null : event.email;
				this.sponsor.phoneNo = event.phoneNo === undefined ? null : event.phoneNo;

				this.sponsor.linkedIn = event.linkedIn === undefined ? null : event.linkedIn;
				this.sponsor.twitter = event.twitter === undefined ? null : event.twitter;
				this.sponsor.facebook = event.facebook === undefined ? null : event.facebook;
				this.sponsor.instagram = event.instagram === undefined ? null : event.instagram;


				this.sponsor.hasDetailsPage = event.hasDetailsPage === undefined ? null : event.hasDetailsPage;
				this.sponsor.position = event.position;
				this.sponsor.bannerCMId = event.bannerCMId === undefined ? null : event.bannerCMId;
				this.sponsor.bannerUrl = event.bannerCMId === undefined ? null : event.bannerUrl;
				this.sponsor.aboutList = event.aboutList === undefined ? [] : event.aboutList;


				if (this.sponsor.aboutList) {
					this.sponsor.aboutList.forEach(element => {
						this.addComponent(element, this.dropDown, this.eventId);
					});
				} else {
					this.sponsor.aboutList = [];
				}
				this.initThings();

				this.getCategoryItemName(eventId, Constants.CATEGORY_SPONSORS, this.sponsor.type).subscribe(event => {
					if (event) {
						console.log('getCategoryItemName	:	' + event);
						this.sponsorTypeText = event;
					}
				});
			}
		});
	}

	getSponsorCount(eventId: string) {
		let x = this.sponsorService.getSponsorsList(eventId);
		x.snapshotChanges().subscribe(list => {
			this.sponsorCount = list.length;
		});
	}

	checkType(key, text) {
		if (key) {
			this.sponsor.type = key;
			this.sponsorTypeText = text
		}
	}

	addAboutElement() {
		this.showDropDown(this.dropDown, this.sponsor, this.eventId);
	}


	uploadImage(event, source) {

		switch (source) {
			case Constants.IMAGE_UPLOAD_TYPE_BANNER:
				console.log('Source Logo :: ', source);
				this.bannerImageFile = event.files[0];
				this.uploadImageToStorage(this.bannerImageFile, firebase, this.sponsor, this.eventId, Constants.CONTENT_M_TYPE_SPONSORS, Constants.IMAGE_UPLOAD_TYPE_BANNER);
				break;

			case Constants.IMAGE_UPLOAD_TYPE_ICON:
				console.log('Source Icon :: ', source);
				this.iconImageFile = event.files[0];
				this.uploadImageToStorage(this.iconImageFile, firebase, this.sponsor, this.eventId, Constants.CONTENT_M_TYPE_SPONSORS, Constants.IMAGE_UPLOAD_TYPE_ICON);
				break;
		}
	}

	// deleteLogoImage() {
	//   this.logoImageFile = null;
	// }

	// deleteIconImage() {
	//   this.iconImageFile = null;
	// }

	submit() {
		this.confirmMessage = null;
		this.isError = false;
		this.errorMessage = [];

		if (this.validate(this.sponsor)) {
			if (!this.sponsorId) {
				this.disableButton = false;
				this.sponsor.position = this.sponsorCount;
				let sponsorKey = this.sponsorService.addSponsorDetails(this.sponsor, this.eventId);
				if (sponsorKey) {
					this.confirmMessage = 'Added Successfully';
				}

			} else {
				this.disableButton = false;

				this.sponsorService.updateSponsorDetails(this.sponsor, this.eventId, this.sponsorId).then(res => {
					this.confirmMessage = 'Update Successfully';
				}).catch(error => {
					this.disableButton = true;
					this.errorMessage = error.message;
				});
			}
			setTimeout(function () {
				this.confirmMessage = null;
				this.disableButton = true;
				this.router.navigate([Constants.SPONSORS_FORM, this.eventId]);
			}.bind(this), 2000);

		} else {
			this.isError = true;
		}
	}

}



// WEBPACK FOOTER //
// /app/src/app/event/sponsors-add-new/sponsors-add-new.component.ts